import styled from 'styled-components';

export const ButtonDelete = styled.div`
    .account-button-delete{
        display: inline-flex;
    }

    .account-button-delete:hover {
        cursor: pointer;
    }

    .account-button-delete-icon{
        width: 32px;
        height: 32px;
        border-radius: 12px;
        color: #3c4455;
        background-color: #e9ecf2;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .account-button-delete-icon.account-button-delete-icon-hover {
        background-color: #d3d8e0;
    }

    .account-button-delete-text{
        margin-left: 12px;
        display: flex;
        align-items: center;
    }

`;